function ArrowLeftIcon({ color, opacity = 0.2 }) {
    return (
        <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.445" y="0.445" width="41.11" height="41.11" rx="20.555" fill="white" />
            <path
                d="M27.1875 21H14.8125M14.8125 21L19.875 15.9375M14.8125 21L19.875 26.0625"
                stroke="#5E718D"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <rect x="0.445" y="0.445" width="41.11" height="41.11" rx="20.555" stroke="#D7DFE9" strokeWidth="0.89" />
        </svg>
    );
}

export default ArrowLeftIcon;
